export default __webpack_public_path__ + "static/media/02.d27fb95f.jpg";